<dialog class="dialog signatureDialog" id="editSignatureDescriptionDialog"
  aria-labelledby="editSignatureDescriptionTitle">
  <div id="editSignatureDescriptionContainer" class="mainContainer">
    <div class="title">
      <span id="editSignatureDescriptionTitle" role="sectionhead"
        data-l10n-id="pdfjs-editor-edit-signature-dialog-title" tabindex="0"></span>
    </div>
    <div id="editSignatureDescriptionAndView">
      <div id="editSignatureDescriptionContainer">
        <label for="editSignatureDescInput" data-l10n-id="pdfjs-editor-add-signature-description-label"></label>
        <span id="editSignatureDescription" class="inputWithClearButton">
          <input id="editSignatureDescInput" type="text" data-l10n-id="pdfjs-editor-add-signature-description-input"
            tabindex="0">
          <button class="clearInputButton" type="button" tabindex="0" aria-hidden="true"></button>
        </span>
      </div>
      <svg id="editSignatureView" xmlns="http://www.w3.org/2000/svg"></svg>
    </div>
    <div class="dialogButtonsGroup">
      <button id="editSignatureCancelButton" type="button" class="secondaryButton" tabindex="0"><span
          data-l10n-id="pdfjs-editor-add-signature-cancel-button"></span></button>
      <button id="editSignatureUpdateButton" type="button" class="primaryButton" disabled tabindex="0"><span
          data-l10n-id="pdfjs-editor-edit-signature-update-button"></span></button>
    </div>
  </div>
</dialog>